import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { quizResult } from "../data/quizResult"; // adjust path if needed

ChartJS.register(ArcElement, Tooltip, Legend);

const ResultPieChart = () => {
  const correctCount = quizResult.answers.filter((q) => q.status === "Correct").length;
  const wrongCount = quizResult.answers.filter((q) => q.status === "Wrong").length;

  const data = {
    labels: ["Correct Answers", "Incorrect Answers"],
    datasets: [
      {
        label: "Quiz Result",
        data: [correctCount, wrongCount],
        backgroundColor: ["#10B981", "#EF4444"],
        borderColor: ["#ffffff", "#ffffff"],
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          color: "#1F2937",
          font: {
            size: 14,
            weight: "bold",
          },
        },
      },
    },
  };

  return (
    <div className="max-w-7xl mx-auto bg-white shadow-lg rounded-2xl px-8 py-6 mt-10 border border-gray-200">
      <h2 className="text-2xl font-bold text-center text-indigo-700 mb-8">
        🎯 Quiz Performance Summary
      </h2>

      {/* Flex layout for chart and table */}
      <div className="flex flex-col lg:flex-row items-start justify-between gap-8 px-4">
        {/* Pie Chart Container */}
        <div className="w-full lg:w-1/3 flex justify-center items-center">
          <div className="w-48 h-48 sm:w-56 sm:h-56 md:w-60 md:h-60">
            <Pie data={data} options={options} width={200} height={200} />
          </div>
        </div>

        {/* Table Section */}
        <div className="w-full lg:w-2/3">
          <h3 className="text-xl font-semibold text-indigo-600 mb-4">📋 Answer Breakdown</h3>
          <div className="overflow-x-auto bg-white rounded-lg shadow-md">
            <table className="min-w-full text-sm text-gray-800">
              <thead className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white">
                <tr>
                  <th className="px-4 py-3 text-left font-semibold">Questions</th>
                  <th className="px-4 py-3 text-left font-semibold">Given Answer</th>
                  <th className="px-4 py-3 text-left font-semibold">Correct Answer</th>
                  <th className="px-4 py-3 text-left font-semibold">Status</th>
                  <th className="px-4 py-3 text-left font-semibold">Detail</th>
                </tr>
              </thead>
              <tbody>
                {quizResult.answers.map((q, index) => {
                  // Ensure question is safely rendered as a string
                  const safeQuestion =
                    typeof q.question === "string"
                      ? q.question
                      : JSON.stringify(q.question);

                  return (
                    <tr
                      key={index}
                      className={`border-b hover:bg-gray-50 ${index % 2 === 0 ? "bg-indigo-50" : ""}`}
                    >
                      <td className="px-4 py-3">
                        <span className="font-bold text-indigo-500">
                          {(index + 1).toString().padStart(2, "0")}.
                        </span>
                        <br />
                        <span>{safeQuestion}</span>
                      </td>
                      <td className="px-4 py-3">{q.given}</td>
                      <td className="px-4 py-3">{q.correct}</td>
                      <td className="px-4 py-3">
                        <span
                          className={`inline-block px-2 py-1 rounded-full text-xs font-bold 
                            ${
                              q.status === "Correct"
                                ? "bg-green-100 text-green-700"
                                : "bg-red-100 text-red-700"
                            }`}
                        >
                          {q.status}
                        </span>
                      </td>
                      <td className="px-4 py-3">
                        <button className="bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white text-xs font-medium px-3 py-1 rounded shadow-sm">
                          View Answer
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResultPieChart;
